<dialog #dialog class="dialog-root" (click)="handleClick($event)">
  <ng-content></ng-content>
</dialog>